import { gql } from '@apollo/client';

export const GET_USER_TRANSACTIONS = gql`
  query GetUserTransactions(
    $filters: TransactionFilterInput
    $pagination: PaginationInput
  ) {
    getUserTransactions(filters: $filters, pagination: $pagination) {
      data {
        _id
        type
        status
        amount
        note
        comment
        createdAt
        updatedAt
        user {
          _id
          name
          email
        }
        txId
        coin
        adjustedAmount
        totalInCrypto
        amountInNGN
        amountInUsd
        withdrawalType
        source
        redbillerStatus
        refundedAt
      providerSessionId
        sourceCollection
        reason
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const GET_ALL_USER_TRANSACTIONS = gql`
  query GetAllUserTransactions(
    $filters: TransactionFilterInput
  ) {
    getAllUserTransactions(filters: $filters) {
      _id
      type
      status
      amount
      note
      comment
      createdAt
      updatedAt
      user {
        _id
        name
        email
      }
      txId
      coin
      adjustedAmount
      totalInCrypto
      amountInNGN
      amountInUsd
      withdrawalType
      source
      redbillerStatus
      refundedAt
      providerSessionId
      sourceCollection
      reason
    }
  }
`; 